import { PERMISSIONS } from "config";
import { UserPermissions } from "lib/services";
import { useEffect, useRef, useState } from "react";
import { TABLE_INDEX } from "view/Page/OrdersPage";

const URL_PARAMS = {
  HARDWARE_SUPPORT_FLYOUT: "flyoutHardwareSupport",
};

interface UseHardwareFlyoutProps {
  setSelectedTable: (tableIndex: number) => void;
  selectedTable: number;
}

export const useHardwareFlyout = (props: UseHardwareFlyoutProps) => {
  const { setSelectedTable, selectedTable } = props;
  const [shouldOpenFlyout, setShouldOpenFlyout] = useState<boolean>(false);
  const openFlyoutRef = useRef<(() => void) | null>(null);

  // Check for hardware permissions
  const hasHardwarePermission = UserPermissions.current.hasPermission(PERMISSIONS.USE_HARDWARE_SHOP);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const flyoutHardwareSupport = urlParams.get(URL_PARAMS.HARDWARE_SUPPORT_FLYOUT);

    // Only proceed if user has hardware permission and the parameter is set to "true"
    if (flyoutHardwareSupport === "true" && hasHardwarePermission) {
      setSelectedTable(TABLE_INDEX.HARDWARE);
      setShouldOpenFlyout(true);
    }
  }, [setSelectedTable, hasHardwarePermission]);

  useEffect(() => {
    if (selectedTable === TABLE_INDEX.HARDWARE && shouldOpenFlyout && openFlyoutRef.current) {
      openFlyoutRef.current();
      setShouldOpenFlyout(false);
    }
  }, [selectedTable, shouldOpenFlyout]);

  return { openFlyoutRef };
};
